<template>
	<el-dialog :model-value="msgShow" @update:model-value="updateMsgShow" :title="activeMsg.title" width="500" @close="cancelOperate">
		<el-descriptions :column="1">
			<el-descriptions-item label="标题">{{ activeMsg.title }}</el-descriptions-item>
			<el-descriptions-item label="类型">{{ activeMsg.types }}</el-descriptions-item>
			<el-descriptions-item label="时间">{{
				activeMsg.create_time ? activeMsg.create_time : activeMsg.send_time
			}}</el-descriptions-item>
		</el-descriptions>
		<template #footer>
			<div class="dialog-footer">
				<el-button @click="cancelOperate">取 消</el-button>
				<el-button @click="viewDetail">查看公告</el-button>
			</div>
		</template>
	</el-dialog>
</template>

<script setup>
// Props
const props = defineProps({
	msgShow: {
		type: Boolean,
		default: false
	},
	activeMsg: {
		type: Object,
		default: () => ({})
	}
})

// Emits
const emit = defineEmits([
	'update:msgShow',
	'cancel-operate',
	'view-detail'
])

// Methods
const updateMsgShow = (value) => {
	emit('update:msgShow', value)
}

const cancelOperate = () => {
	emit('cancel-operate')
}

const viewDetail = () => {
	emit('view-detail')
}
</script>

<style scoped lang="scss">
.dialog-footer {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
}
</style> 